var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main-inner',{attrs:{"title":"快检统计"}},[_c('inspect-data'),_c('inspect-time-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }